import { Typography } from "antd";
import styled from "styled-components";

import { FONT_VARIANTS, FONT_WEIGHTS } from "../Typography.constants";
import { TLinkStyleProps } from "./Link.types";

export const LinkStyled = styled(Typography.Link)<TLinkStyleProps>`
    font-weight: ${props => FONT_WEIGHTS[props.$weight]};
    ${props => FONT_VARIANTS[props.$variant]};
`;
